export default __webpack_public_path__ + "static/media/f_wdt_c_1.9ba028d8.mp3";